<template>
      <a-col>
        <div>
          <label class="from_input_title" :class="fieldRequiredColorData.nameErrorStr">姓名<span class="required_star">*</span></label>
          <a-input size="large" v-model="name" @change="saveCurrentIdentidyInfo">
            <a-tooltip v-if="inputVerificationResult.isNameEmpty || inputVerificationResult.hasNameIllegalCharacters" slot="suffix">
              <a-icon type="warning" style="color: #FF6565" />
            </a-tooltip>
          </a-input>
          <p class="errTips" v-if="inputVerificationResult.isNameEmpty">請輸入姓名</p>
          <p class="errTips">{{inputVerificationResult.hasNameIllegalCharacters ? '長度需小於等於32個字,符號僅能包含：.-_': ''}}</p>
        </div>
        <div>
          <label class="from_input_title" :class="fieldRequiredColorData.carNoErrorStr">車號<span class="required_star">*</span></label>
          <a-input size="large" v-model="carNo" placeholder="車號須包含「-」" :maxLength="8" @change="saveCurrentIdentidyInfo">
            <a-tooltip v-if="inputVerificationResult.isCarNoInvalid" slot="suffix">
              <a-icon type="warning" style="color: #FF6565" />
            </a-tooltip>         
          </a-input>
          <p class="errTips">{{inputVerificationResult.isCarNoInvalid ? '請輸入車號' : ''}}</p>
        </div>
        <div>
          <label class="from_input_title" :class="fieldRequiredColorData.phoneErrorStr">手機號碼<span class="required_star">*</span></label>
          <a-input size="large" v-model="phone" placeholder="09xx-xxx-xxx" :maxLength="12" @change="saveCurrentIdentidyInfo">
            <a-tooltip v-if="inputVerificationResult.isPhoneInvalid" slot="suffix">
              <a-icon type="warning" style="color: #FF6565" />
            </a-tooltip>          
          </a-input>
          <p class="errTips">{{inputVerificationResult.isPhoneInvalid ? '請輸入手機號碼' : ''}}</p>
        </div>
      </a-col>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    export default {
        name: 'ProvisioningIdentidy',
        data() {
          return {
            name: '',
            carNo: '',
            phone: '',              
          }
        },
        mounted() {
          const { name, carNo, phone } = this.identidyInfo;
          this.name = name;
          this.carNo = carNo;
          this.phone = phone;
        },
        methods: {
          ...mapActions('identidyInfo', ['identidyInfoAction']),
          async saveCurrentIdentidyInfo() {
            try {
              if (this.info.phone) this.forcePhoneFormat();
              this.identidyInfoAction(this.info);
            } catch (error) {
              console.log(error);
            }
          },
          forcePhoneFormat() {
            // console.log(this.phone, this.phone.length);
            // 強制手機號碼第一碼為0
            if (this.phone.length === 1) this.phone = '0';
            // 強制手機號碼第二碼為9
            if (this.phone.length === 2) this.phone = '09';

            // 當目前的號碼長度是5，自動補上'-'做分隔(考慮按下返回鍵，長度從6變5)
            if (this.phone.length === 5) {
              if (this.phone.charAt(4) !== '-') {
                this.phone = `${this.phone.slice(0, -1)}-${this.phone.slice(-1)}`;
              }
            }
            // 當目前的號碼長度是9，自動補上'-'做分隔(考慮按下返回鍵，長度從10變9)
            else if (this.phone.length === 9) {
              if (this.phone.charAt(8) !== '-') {
                this.phone = `${this.phone.slice(0, -1)}-${this.phone.slice(-1)}`;
              }
            }
            else {
              // 檢查輸入的最後一個字元，是否有非數字的
              if (/[^\d]/g.test(this.phone.charAt(this.phone.length - 1))) this.phone = this.phone.slice(0, -1);
            }
          }
        },
        computed: {
          ...mapState('identidyInfo', ['identidyInfo']),
          ...mapState('identidyOpenStatus', ['deviceUid']),
          ...mapState('identidyInputVerification', ['inputVerificationResult']),
          info() {
            return {
              name: this.name || '',
              carNo: this.carNo || '',
              phone: this.phone || '',
            }
          },
          fieldRequiredColorData() {
            return {
              nameErrorStr: (this.inputVerificationResult.isNameEmpty || this.inputVerificationResult.hasNameIllegalCharacters ?  'title_error_color' : ''),
              carNoErrorStr: (this.inputVerificationResult.isCarNoInvalid ?  'title_error_color' : ''),
              phoneErrorStr: (this.inputVerificationResult.isPhoneInvalid ?  'title_error_color' : ''),
            }
          }
        },
    }
</script>

<style lang="scss" scoped>
  .errTips {
    margin-top:4px;
    color: #FF6565;
    line-height: 24px;
  }

  .title_error_color.from_input_title {
    color: #FF6565;
  }

  .ant-input {
      border-radius: 8px;
      border: 1px solid rgba(19, 34, 149, 0.1);
      &:focus {
        border-color: #C0E560;
        box-shadow: none;
      }
  }

</style>